module.exports = __webpack_public_path__ + "img/filter_icon.c69217ba.svg";